import {Component, ComponentFactoryResolver, OnDestroy, OnInit} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {select, Store} from '@ngrx/store';
import {IDac6ReporterState} from '../../store/reducers/dac6-reporter.reducer';
import {take, takeUntil} from 'rxjs/operators';
import {getViewType, ParticleState} from '@shared/store/reducers/particle.reduer';
import {SmartGridService} from '@core/services/smart-grid.service';
import {ParticleService} from '@core/services/particle.service';
import {getSmartGridFieldSectionInfos} from '@shared/store/selectors/smart-grid.selectors';
import {
  CreateQuarterlyFilingCommand, CreateYearlyFilingCommand,
  MapCaseWithTransactionCommand,
  SyncProjectEntityToCompanyCommand,
  SyncProjectTransactionToCompanyCommand
} from '../../commands/dac6-reporter.command';
import {CommandService} from '@core/services/command.service';
import {DialogService} from '@shared/services/dialog-service';
import {GetCheckSumAction, SetViewTypeAction} from '@shared/store/actions/particle.actions';
import {AuthGuard} from '@core/services/auth-guard.service';
import {BreadcrumbModel} from '@shared/models/breadcrumb.model';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {getVirtualGridSelectedIndex} from '@shared/store/selectors/virtual-grid.selector';
import {Dac6ReporterApiService} from '../../services/dac6-reporter.service';
import {DialogModel} from '@shared/models/dialog.model';
import {CleanWorkflowDataAction} from '../../../workflow/store/workflow.actions';
import {getQueryResponse} from '@shared/store/selectors/query.selector';
import {QueryProvider} from '@shared/queries/query-provider';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import {PlatformCommand, PlatformCommandResponse} from '@shared/commands/command-base';
import { PlatformSidebarState } from '@shared/components/platform-sidebar/store/platform-sidebar.reducer';
import { SetActivityFeedAction } from '@shared/components/platform-sidebar/store/platform-sidebar.action';
import { FileStoreCommonService } from '@features/file-manager/services/file-store-common.service';
import {QueryModel} from "@shared/models/query-model";
import {DeleteQueryAction} from "@shared/store/actions/query.actions";
import {
  IPlatformToolComponent,
  IPlatformToolHandler
} from "@shared/components/platform-tool/platform-tool-container/platform-tool-component";
import {MagicLinkModel} from "@shared/models/platform-tool-models";
import {Api} from "@shared/constants/common-field.constants";


@Component({
    standalone: false,
    selector: 'lib-transactions-content',
  templateUrl: './transactions-content.component.html',
  styleUrls: ['./transactions-content.component.scss']
})
export class TransactionsContentComponent implements OnInit, OnDestroy, IPlatformToolComponent {

  filterId = 'Dac6-Transaction';
  endpoint = 'Dac6Api';
  sourceConfigKey: string;
  currentSelectedItems: string[];
  flag: boolean;
  deleteDisabled: boolean;
  numberOfTabs$: Observable<any>;
  private queryModels: QueryModel[] = [];
  unSubscribe$ = new Subject<void>();
  hasNoExtraTab : boolean;
  invalidateSubject: InvalidateSubject;
  breadcrumbs: BreadcrumbModel[];
  tabs: any[];
  selectedTab: any;
  actions: any[];
  viewType: string;
  selectedFieldSectionIndex$: Observable<number>;
  selectedTabIndex: number;
  cases: any;
  syncCompleted: boolean;
  selectedFieldSectionIndex = 0;
  yearlyFilingItemId: string;
  selectedCaseArrangementId: string;
  handler: IPlatformToolHandler;
  magicLinkModel: MagicLinkModel;

  constructor(private router: Router, private store: Store<IDac6ReporterState>,
              private particleService: ParticleService,
              private smartGridService: SmartGridService,
              private particleStore: Store<ParticleState>,
              private activatedRoute: ActivatedRoute,
              protected commandService: CommandService,
              private dialogService: DialogService,
              private dac6RepoterApiService: Dac6ReporterApiService,
              private componentFactoryResolver: ComponentFactoryResolver,
              private platformSidebarStore: Store<PlatformSidebarState>,
              private queryState: Store<IQueryState>,
              private fileStoreCommonService: FileStoreCommonService,
              private fuseSplashscreen: FuseSplashScreenService) {
    this.breadcrumbs = [
      <BreadcrumbModel>{
        id: 'Case',
        title: 'DAC6 & MDR Reporter',
        type: 'Case',
        relativeUrl: 'dac6-reporter/overview'
      },
      <BreadcrumbModel>{
        id: 'Transactions',
        title: 'Transactions',
        type: 'Transactions',
        relativeUrl: 'dac6-reporter/transactions'
      }
    ];
    this.actions = [];
    this.tabs = [];
    this.viewType = 'Expanded';
    this.actions = [];
    this.sourceConfigKey = 'Dac6-Transaction';
    this.invalidateSubject = new InvalidateSubject();
    this.tabs = [
      {
        id: 0,
        header: 'General',
        index: 0,
        invalidateSubject: new InvalidateSubject(),
        sourceKey : 'Dac6-Transaction',
        serviceName: 'TransactionDynamicItemService'
      },
      {
        id: 1,
        header: 'Consolidated',
        index: 1,
        invalidateSubject: new InvalidateSubject(),
        sourceKey : 'Dac6-Consolidated-Transaction',
        serviceName: 'ConsolidateTransactionDynamicItemService'
      }
    ];
    // particleService.registerCellComponent('EtCellDecorator', EtCellDecoratorComponent);
  }

  ngOnInit() {
    const command = new SyncProjectEntityToCompanyCommand(false);
    this.actions = [
      {
        text: 'Manage Transactions',
        doAction: this.manageTransactions,
        self: this
      },
      // TODO: apply filter is a component in toolbar
      // {
      //   text: 'Apply Filter',
      //   doAction: this.apply,
      //   self: this
      // },
      {
        text: 'Manage Fields',
        doAction: this.manageSection,
        self: this
      },
      {
        text: 'Export',
        doAction: this.exportTransaction,
        self: this
      }
    ];
    this.fuseSplashscreen.show();
    this.commandService.executeCommand(command).pipe().subscribe(commandState => {
      console.log(commandState);
      this.fuseSplashscreen.hide();
      if (commandState.Payload.ConfirmationNeeded) {
        this.dialogService.showYesNoDialog('Confirm Sync', `You were working with the entities of project '${commandState.Payload.Configuration.ProjectModel.Name}'. Do you want to sync with the current project?`)
          .subscribe(state => {
            if (state.action === 'OK') {
              const command = new SyncProjectEntityToCompanyCommand(true);
              this.fuseSplashscreen.show();
              this.commandService.executeCommand(command).subscribe(value => {
                console.log(commandState);
                this.fuseSplashscreen.hide();
                this.syncCompleted = true;
                this.prepareTransactions();
              }, error => {
                this.fuseSplashscreen.hide();
                console.log(error);
              });
            } else {
              this.syncCompleted = true;
              this.prepareTransactions();
            }
          });
      } else {
        this.syncCompleted = true;
        this.prepareTransactions();
      }
    }, error => {
      this.fuseSplashscreen.hide();
      console.log(error);
    });
    this.selectTab(0);
    // this.prepareTransactions();

    // const activityInfo = {type: 'Tool', 'id': 'dac6-transactions', 'title': 'Transactions', isDefault: true};
    // this.platformSidebarStore.dispatch(new SetActivityFeedAction(activityInfo));

    this.store.pipe(takeUntil(this.unSubscribe$), select(getQueryResponse, 'ArrangementRowById')).subscribe(response=>{
      let arrangementData = {};
      if(response && response.item && response.item.cells && this.yearlyFilingItemId && this.selectedCaseArrangementId){
        arrangementData = response.item.cells;
        let dialogModel = DialogModel.create('Create Filing',
          'CreateFilingDialogComponent',
          {'fromArrangement': true, 'arrangementData': arrangementData}, '600px', '700px', true);
        this.dialogService.showOkCancelDialog(dialogModel).pipe(takeUntil(this.unSubscribe$))
          .subscribe(actionState => {
            if (actionState && actionState.action === 'OK') {
              if(actionState.data && actionState.data.input && actionState.data.input.formVersionData){
                let formVersionData = actionState.data.input.formVersionData;
                const command = new CreateYearlyFilingCommand(this.yearlyFilingItemId, this.selectedCaseArrangementId, formVersionData.reportingCountryCode, formVersionData.formTemplateId, formVersionData.categoryModel);
                this.commandService.executeCommand(command).subscribe(state => {
                  if (state) {
                    this.router.navigateByUrl('dac6-reporter/filing/annual');
                  }
                });
              }
            }
          })
      }
    });
  }
  private selectTab(index: number) {
    this.selectedFieldSectionIndex = index;
    this.selectedTab = this.tabs[this.selectedFieldSectionIndex];
  }
  onTabIndexChange(event) {
    this.selectTab(event);
  }
  private prepareTransactions() {
    this.store.dispatch(new GetCheckSumAction('[CompanyId]-dac6-manage-transaction-workflow', 'Dac6Api'));
    this.currentSelectedItems = [];
    this.flag = false;
    this.deleteDisabled = true;
    this.smartGridService.initDataProvider(this.sourceConfigKey);
    // this.store.dispatch(new GetTransactionsEntitiesAction(1, 1000));
    // this.store.dispatch(new GetStreamsAction());
    this.numberOfTabs$ = this.particleStore.pipe(select(getSmartGridFieldSectionInfos));
    this.numberOfTabs$.pipe(takeUntil(this.unSubscribe$)).subscribe((payload: any) => {
      if (payload) {
        if (payload.length > 1) {
          this.hasNoExtraTab = false;
        } else {
          this.hasNoExtraTab = true;
        }
      }
    });
    this.particleStore.pipe(select(getViewType)).subscribe(viewType => {
      this.viewType = viewType;
    });
    /*this.selectedFieldSectionIndex$ = this.store.pipe(select(getVirtualGridSelectedIndex, this.sourceConfigKey));
    this.selectedFieldSectionIndex$.pipe(takeUntil(this.unSubscribe$)).subscribe(state => {
      if (state >= 0 && state < this.tabs.length) {
        this.selectedTab = this.tabs[state];
      }
      this.selectedTabIndex = state;
    });*/
  }

  onCellEditorClosed(event) {
    console.log(event);
    this.router.navigate(['']);
  }

  onSelectionChanged(event) {
    if (event.fieldDefinition.key === 'CaseId') {
      const transactionCode = event.item.cells['TransactionCode'].value;
      const dialogModel = DialogModel.create('Assign Case(s)', 'Dac6AssignTransactionCellEditorComponent', {
        caseId: event.item.cells['CaseId'].value,
        item: event.item,
        fieldDefinition: event.fieldDefinition
      });
      dialogModel.minWidth = '400px';
      dialogModel.maxWidth = '400px';
      // dialogModel.componentFactoryResolver = this.componentFactoryResolver;
      this.dialogService.showOkCancelDialog(dialogModel)
        .pipe(takeUntil(this.unSubscribe$))
        .subscribe((actionState: any) => {
          if (actionState && actionState.action === 'OK') {
            const command = new MapCaseWithTransactionCommand(transactionCode, actionState.data.input['CaseIds']);
            this.commandService.executeCommand(command).pipe().subscribe(commandState => {
              this.selectedTab.invalidateSubject.invalidate();
            });
          }

        });
      return;
    }
    if (event.fieldDefinition.key === 'ConsolidatedTable'){
      this.openEditor(event);
      return;
    }
    if (event.item.cells['CaseId'].value === null) {
      this.dialogService.showDialogMessage('Message', 'Please assign a case first');
      return;
    }

    if (event.action && event.action.id === 'OpenCase') {
      this.onSelectCase(event);
      return;
    }
    if (event.action && event.action.id === 'OpenCaseFolder') {
      this.onSelectCase(event);
      return;
    }
    if (event.action && event.action.id === 'CreateAnnualFiling') {
      this.onSelectCase(event);
      return;
    }

    if (event.fieldDefinition.key === 'Hallmarks') {
      this.dialogService.showCellEditorDialog(event.item, event.fieldDefinition).subscribe(state => {
      });
      return;
    }
    if (event.fieldDefinition.key === 'Suggested_Hallmarks') {
      this.dialogService.showCellEditorDialog(event.item, event.fieldDefinition, '500px', '500px').subscribe(state => {
      });
      return;
    }
    if (event.action && event.action.id === 'Edit') {
      this.dialogService.showCellEditorDialog(event.item, event.fieldDefinition, '600px', '600px', this.selectedTab.sourceKey).subscribe(state => {
        if (state.action === 'OK') {
          if (event.item.cells[event.fieldDefinition.key]) {
            const fieldValue = event.item.cells[event.fieldDefinition.key].value;
            const updateCommand = new PlatformCommand('UpdateDac6TransactionCommand', 'DAC6Api');
            updateCommand.fieldValues['ItemId'] = event.item.id;
            updateCommand.fieldValues[event.fieldDefinition.key] = fieldValue;
            this.commandService.executePlatformCommand(updateCommand).subscribe(response => {
              console.log(response);
              this.selectedTab.invalidateSubject.invalidate();
            });
          } else {
            console.log(`Something wrong. FieldValue not found for fieldKey ${event.fieldDefinition.key}-----------`);
          }
        }
      });
      return;
    }
    if (this.flag) {
      this.currentSelectedItems = [];
    }
    this.flag = false;
    event.deselectedRows.forEach(item => {
      const index = this.currentSelectedItems.indexOf(item.dataItem.id);
      if (index > -1) {
        this.currentSelectedItems.splice(index, 1);
      }
    });
    event.selectedRows.forEach(item => {
      this.currentSelectedItems.push(item.dataItem.id);
    });
    if (this.currentSelectedItems.length > 0) {
      this.deleteDisabled = false;
    } else {
      this.deleteDisabled = true;
    }
  }
  openCaseFromTransactionActivityCommand(transactionId,caseId){
    const command = new PlatformCommand('OpenCaseFromTransactionActivityCommand', 'Dac6Api');
    command.fieldValues['TransactionId'] = transactionId;
    command.fieldValues['CaseId'] = caseId;
    this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(response => {
        console.log('commandState', response);
      },
      error => {
        console.error('Failed to basket manage section', error);
      });
  }
  ViewCaseDocumentFromTransactionActivityCommand(transactionId,caseId){
    const command = new PlatformCommand('ViewDocumentActivityCommand', 'Dac6Api');
    command.fieldValues['TransactionId'] = transactionId;
    command.fieldValues['CaseId'] = caseId;
    command.fieldValues['SourceType'] = 'Dac6-Transaction';
    this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(response => {
        console.log('commandState', response);
      },
      error => {
        console.error('Failed to basket manage section', error);
      });
  }

  /*onFieldSectionChanged($event) {
    if ($event) {
      if (this.tabs.length) {
        this.tabs.splice(0, this.tabs.length);
      }
      let index = 0;
      if ($event.length > 0) {
        $event.forEach(f => {
          this.tabs.push({id: f.id, header: f.header, index: index++});
        });
        if (!this.selectedTab) {
          if (this.selectedTabIndex >= 0) {
            this.selectedTab = this.tabs[this.selectedTabIndex];
          } else {
            this.selectedTab = this.tabs[0];
          }
          this.invalidateSubject.invalidate(`Selected Index: ${this.selectedTab.index}`);
        }
      }
    }
  }*/

  onSelectedTabChanged($event) {
    this.selectedTab = $event;
    this.invalidateSubject.invalidate(`Selected Index: ${this.selectedTab.index}`);
  }

  viewTypeChanged($event) {
    this.particleStore.dispatch(new SetViewTypeAction($event));
  }

  compactViewType() {
    this.particleStore.dispatch(new SetViewTypeAction('Compact'));
  }

  addSection() {
    this.router.navigate(['add-section/' + this.sourceConfigKey], {relativeTo: this.activatedRoute});
  }

  // manageSection() {
  //   const relativeUrl = 'dac6-reporter/transactions';
  //   this.router.navigate(['manage-section/' + this.sourceConfigKey], {relativeTo: this.activatedRoute});
  // }

  exportTransaction() {
    this.router.navigate(['export'], {relativeTo: this.activatedRoute});
  }

  startDataSurvey() {
    this.dialogService.showAndStartSurvey('', '', false, {'SourceTypes': ['Dac6-Transaction']});
  }

  manageTransactions() {
    // Sync
    const command = new SyncProjectTransactionToCompanyCommand(true);
    this.commandService.executeCommand(command).pipe().subscribe(commandState => {
      console.log(commandState);
      this.router.navigate(['manage-transaction'], {relativeTo: this.activatedRoute});
    });
  }

  navigateToCaseFolder(event: any, selectedCase: any) {
    if (event.action && event.action.tags.length) {
      let relativePath = event.action.tags[0];
      const caseId = selectedCase.caseId;
      relativePath = relativePath.replace('[CASE_ID]', caseId);
      relativePath = relativePath.replace('Filings', 'Arrangements');
      // const relativeUrl$ = this.queryState.pipe(select(getQueryResponse, 'UrlByRelativePath'))
      //   .pipe(take(2));
      // relativeUrl$.subscribe((state: any) => {
      //   if (state) {
      //     this.router.navigateByUrl(state);
      //   }
      // });

      // QueryProvider.invokeQuery(this.queryState, 'UrlByRelativePath', {'[RELATIVE_PATH]': relativePath});
      this.fileStoreCommonService.navigateToClientFolderUsingRelativepath(relativePath);
    }
  }

  ngOnDestroy(): void {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
    this.queryModels.forEach(q => {
      this.queryState.dispatch(new DeleteQueryAction(q, null, null));
    });
  }

  manageSection(sourceType:string) {
    const command = new PlatformCommand('CreateManageFieldMagicLinkCommand',Api.DAC6);
    command.fieldValues['SourceType'] = sourceType;
    this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe((response: any) => {
      console.log('commandState', response);
      if (response.fieldValues['RedirectUrl']) {
        this.router.navigateByUrl(response.fieldValues['RedirectUrl']);
      }
      },
      error => {
        console.error('Failed to managesection', error);
      });
  }

  public openEditor(event: any) {
    let minWidth = '400px';
    let maxWidth = '1500px';
    if(event.fieldDefinition.key === 'ConsolidatedTable'){
      minWidth = '1200px';
    }
    this.dialogService.showCellEditorDialog(event.item, event.fieldDefinition, minWidth, maxWidth, this.selectedTab.sourceKey)
      .subscribe(state => {
        console.log('After Edit', state);
        if (state.action === 'OK') {

        }
      });
  }

  private onSelectCase(event: any) {
    const dialogModel = DialogModel.create('Select', 'TransactionCaseDialogsComponent', {
      item: event.item,
      fieldDefinition: event.fieldDefinition
    });
    dialogModel.minWidth = '800px';
    dialogModel.maxWidth = '800px';
    this.dialogService.showOkCancelDialog(dialogModel)
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe((actionState: any) => {
        if (actionState && actionState.action === 'OK') {
          this.handleSelectCaseAction(event, dialogModel.input['selectedCase']);
        }

      });
  }

  private handleSelectCaseAction(event: any, selectedCase: any) {
    switch(event.action.id){
      case 'OpenCase':
        this.router.navigate(['./detail', selectedCase.arrangementId], {relativeTo: this.activatedRoute});
        this.openCaseFromTransactionActivityCommand(event.item.id,selectedCase.caseId);
        break;
      case 'OpenCaseFolder':
        this.navigateToCaseFolder(event, selectedCase);
        if (event.item.id) {
          this.ViewCaseDocumentFromTransactionActivityCommand(event.item.id,selectedCase.caseId);
        }
        break;
      case 'CreateAnnualFiling':
        this.yearlyFilingItemId = event.item.id;
        this.selectedCaseArrangementId = selectedCase.arrangementId;
        QueryProvider.invokeQuery(this.store, 'ArrangementRowById', {'[ID]': selectedCase.arrangementId});
        break;
      default:
        break;
    }
  }

  onAfterExecuteNextCommand(nextCommandResponse: PlatformCommandResponse) {
  }

  onAfterExecutePreviousCommand(previousCommandResponse: PlatformCommandResponse) {
  }

  onBeforeExecuteNextCommand(): boolean {
    return false;
  }

  onBeforeExecutePreviousCommand(): boolean {
    return false;
  }

  onLoad() {
  }
}
